import Input from "../lowLevelComponents/Input";
import TextArea from "../lowLevelComponents/TextArea";
import CheckBoxType from "../lowLevelComponents/CheckBoxType";
import { IFormController } from "../types";
import RadioButton from "../lowLevelComponents/RadioButton";
import FreeSoloAutocomplete from "../lowLevelComponents/FreeSoloAutocomplete";
import FormFileUpload from "../lowLevelComponents/FileUpload";
import { FormHelperText, Typography } from "@mui/material";
import SelectType from "../lowLevelComponents/SelectType";
import MyMultiSelect from "../lowLevelComponents/MyMultiSelect";
import TelInput from "../lowLevelComponents/TelInput";
import FormDatePicker from "../lowLevelComponents/FormDatePicker";
import FormTimePicker from "../lowLevelComponents/FormTimePicker";
import AutoCompleteSelect from "../lowLevelComponents/AutoCompleteSelect";
import MultiTreeSelect from "../lowLevelComponents/MultiTreeSelect";
import MultiSelectAll from "../lowLevelComponents/MultiSelectAll";
import CheckBoxTerms from "../lowLevelComponents/CheckBoxTerms";
import { useTranslation } from "react-i18next";

const FormController = (props: IFormController) => {
  if (!props || !props.formik) {
    return <></>;
  }
  const { t } = useTranslation();

  const {
    control,
    hidden = false,
    errors = props.formik.errors[props.name] &&
      props.formik.touched[props.name],
    ...rest
  } = props;

  const _rest = { ...rest, error: errors };
  // Einai mono string? or string[]
  // if string -> String(errMsg)
  const errMessage = props.formik.errors[props?.name] || "";

  const splitAndTranslate = (errorMessage: any) => {
    const regex = /(\D+)(\d+)/;
    const matches = errorMessage?.match(regex);
    if (!matches) {
      const translatedErrorMessage = t(errorMessage?.trim());
      return translatedErrorMessage;
    }
    const nonNumericPart = matches[1] || "";
    const numericPart = matches[2] || "";
    const translatedNonNumericPart = t(nonNumericPart.trim() || "");
    return `${translatedNonNumericPart} ${numericPart}`;
  };

  const loadErrors = props.formik.errors[props?.name] &&
    props.formik.touched[props?.name] && 
    (
      <FormHelperText error>
        <Typography
          variant='body1'
          sx={{
            marginTop: "16px",
            fontWeight: "bolder",
          }}
        >
          {`${splitAndTranslate(errMessage as any)}`}
        </Typography>
      </FormHelperText>
    );
  let SelectedComp = <></>;

  switch (control) {
  case "input": {
    SelectedComp = <Input {..._rest} />;
    break;
  }
  case "telInput": {
    SelectedComp = <TelInput {..._rest} />;
    break;
  }
  case "textarea": {
    SelectedComp = <TextArea {..._rest} />;
    break;
  }
  case "select": {
    SelectedComp = <SelectType {..._rest} />;
    break;
  }
  case "autoselect": {
    SelectedComp = <AutoCompleteSelect {..._rest} />;
    break;
  }
  case "autocomplete": {
    SelectedComp = <MyMultiSelect {..._rest} />;
    break;
  }
  case "radio": {
    SelectedComp = <RadioButton {..._rest} />;
    break;
  }
  case "chips": {
    SelectedComp = <FreeSoloAutocomplete {..._rest} />;
    break;
  }
  case "checkboxTerms": {
    SelectedComp = <CheckBoxTerms {..._rest} />;
    break;
  }
  case "checkbox": {
    SelectedComp = <CheckBoxType {..._rest} />;
    break;
  }
  case "file": {
    SelectedComp = <FormFileUpload {..._rest} />;
    break;
  }
  case "date": {
    SelectedComp = <FormDatePicker {..._rest} />;
    break;
  }
  case "time": {
    SelectedComp = <FormTimePicker {..._rest} />;
    break;
  }
  case "selectWithCheckboxes": {
    SelectedComp = <div></div>;
    break;
    // <MultipleTreeSelect {..._rest} />;
  }

  case "multiselecttree": {
    SelectedComp = <MultiTreeSelect {...rest} />;
    break;
  }

  case "multiselectall": {
    SelectedComp = <MultiSelectAll {..._rest} />;
    break;
  }
  default: {
    SelectedComp = <div></div>;
    break;
  }
  }

  return (
    <>
      {!hidden && SelectedComp}
      {loadErrors}
    </>
  );
};

export default FormController;
